import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { AnaBizStatementOfChargesSelectSubHeaderComponent } from './ana-biz-statement-of-charges-select-sub-header.component';
import { StaticMsgModule } from '@lib/pipes';
import { RouterModule } from '@angular/router';
import { TextTooltipModule } from '@lib/components';
import { IfScreenSizeModule } from '@common/directives/if-screen-size/if-screen-size.module';

@NgModule({
  declarations: [AnaBizStatementOfChargesSelectSubHeaderComponent],
  imports: [CommonModule, RouterModule, StaticMsgModule, TextTooltipModule, IfScreenSizeModule],
  exports: [AnaBizStatementOfChargesSelectSubHeaderComponent],
})
export class AnaBizStatementOfChargesSelectSubHeaderModule {}
